import React from "react";
import "./modalOne.css";

const ModalOne = ({
  title = "My modal",
  children,
  showModal,
  handleClose,
  maxWidth,
  maxHeight,
  footer,
}) => {
  // For every component containing a form passed into this modal, pass the form ref through to the form in the passed component to allow for reset of the form. e.g <Login reset={form} />, inside Login component: pass <form ref={reset}>input goes here</form>

  return (
    <div className={`modal__wrapper ${showModal && "show"}`}>
      <div
        className='popup__outer'
        style={{ maxWidth: maxWidth, maxHeight: maxHeight }}
      >
        <div className='popup__title__wrapper'>
          <h2 className='popup__title'>{title}</h2>
          <div>
            <i
              className='mdi mdi-close modal__close'
              onClick={() => {
                handleClose();
              }}
            ></i>
          </div>
        </div>
        <div className='popup__box' style={{ maxHeight: maxHeight }}>
          <div className='profile__content'>{children}</div>
        </div>
        {footer}
      </div>
    </div>
  );
};

export default ModalOne;
